enum LinkType {
  EMAIL,
  DOCUMENT,
  WEB,
  ARTICLE,
}

export default LinkType;
